<template>
    <div id="FormImage">
        <div :class="`form-image form-image-align-${align}`">
            <img :src="asset" :style="{ width: imageWidth + 'px', height: imageHeight + 'px' }" />
        </div>
    </div>
</template>
<script>
export default {
    name: "FormImage",
    props: {
        align: String,
        item: Object,
        asset: String,
        imageWidth: String,
        imageHeight: String,
    },
    data() {
        return {
            localAlign: this.align || "center",
        };
    },
};
</script>
<style lang="scss" scoped>
#FormImage {
    .form-image {
        display: flex;
        justify-content: center;
        max-width: 750px;
    }

    .form-image-align-left {
        display: flex !important;
        justify-content: flex-start !important;
    }

    .form-image-align-right {
        display: flex !important;
        justify-content: flex-end !important;
    }
}
</style>
